/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_json_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON input`)
};

const es_cj_json_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada JSON`)
};

const de_cj_json_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON-Eingabe`)
};

const nl_cj_json_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON-invoer`)
};

const fr_cj_json_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrée JSON`)
};

const it_cj_json_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input JSON`)
};

const pt_br2_cj_json_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada de JSON`)
};

const pt_cj_json_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada de JSON`)
};

const ja_cj_json_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 入力`)
};

const zh_cj_json_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 输入`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_json_input = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_json_input(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_json_input", locale)
	if (locale === "en") return en_cj_json_input(inputs)
	if (locale === "es") return es_cj_json_input(inputs)
	if (locale === "de") return de_cj_json_input(inputs)
	if (locale === "nl") return nl_cj_json_input(inputs)
	if (locale === "fr") return fr_cj_json_input(inputs)
	if (locale === "it") return it_cj_json_input(inputs)
	if (locale === "pt-BR") return pt_br2_cj_json_input(inputs)
	if (locale === "pt") return pt_cj_json_input(inputs)
	if (locale === "ja") return ja_cj_json_input(inputs)
	return zh_cj_json_input(inputs)
};